<template>

  <div class="mit-my-storage-page mit-page">
      List current user's storage here
  </div>
</template>

<script>
  import BaseMitLoading from '../../base/components/BaseMitLoading.vue';

  export default {
    name: 'MitMyStoragePage',
    components: {
      BaseMitLoading
    },
    data: function() {
      return {

      }
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    created() {

    },
    methods: {
      test(){

      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
</style>
